// see docs/EXTRACTED_COMMENTS.md#c192

const defaultFlags = {
    subscriptionManager: true,
    telemetry: true,
    bulkProtocol: true,
    dependencyGraphAdvisory: true,
    taskScheduler: true,
    versioningService: true,
    backpressure: false,
    scaling: true,
    enableQuietWindow: true,
    enableDegradedModes: true,
    structuredCache: true,
    mediaServiceWorker: true,
    // see docs/EXTRACTED_COMMENTS.md#c658
    render_measurement_lane_canvas: false,
    // see docs/EXTRACTED_COMMENTS.md#c678
    variableRowHeights: true,
};

type Flags = typeof defaultFlags & Record<string, boolean>;
const runtimeOverrides: Partial<Flags> = (() => {
    try {
        const w: any = (typeof window !== "undefined") ? window : undefined;
        const overrides = w?.FEATURE_FLAGS;
        if (overrides && typeof overrides === "object") return overrides as Partial<Flags>;
    } catch (_e) {}
    return {};
})();

export const FeatureFlags: Flags = {
    ...defaultFlags,
    ...runtimeOverrides,
};

export function isEnabled<K extends keyof Flags>(key: K): boolean {
    return !!FeatureFlags[key];
}


